import Vue from "vue";
import VueRouter from "vue-router";

// Routes
import { canNavigate } from "@/libs/acl/routeProtection";
import {
	isUserLoggedIn,
	getUserData,
	getHomeRouteForLoggedInUser,
} from "@/auth/utils";
import apps from "./routes/apps";
import company_apps from "./routes/company_apps";
import dashboard from "./routes/dashboard";
import hatchery_apps from "./routes/hatchery_apps";
import uiElements from "./routes/ui-elements/index";
import pages from "./routes/pages";
import chartsMaps from "./routes/charts-maps";
import formsTable from "./routes/forms-tables";
import others from "./routes/others";
import company_dashboard from "./routes/company_dashboard";
import features from "./routes/features";

Vue.use(VueRouter);
let dynamicRoutes = [];
const userData = getUserData();
let homeDashboard = "auth-login";
if (userData) {
	// userData.role is a human-readable label ("Super Admin"), not the
	// machine slug — comparing it against "super_admin" never matched, so
	// every super_admin login silently fell through to the owner routes
	// below. The real slug lives on the roles[] pivot record.
	const roleSlug = Array.isArray(userData.roles) && userData.roles.length > 0
		? (typeof userData.roles[0] === 'object' ? userData.roles[0].slug : userData.roles[0])
		: null;
	const userRole = roleSlug ||
		(typeof userData.role === 'string' ? userData.role.toLowerCase().replace(/\s+/g, '_') : 'admin');
	if (userRole === "super_admin") {
		dynamicRoutes = apps;
		// super_admin has no single owned farm/company, so the per-farm
		// Broiler/Breeder/Layer dashboard (company-dashboard-ecommerce) is
		// meaningless for them — every KPI shows 0. Land them on the
		// cross-company Analytics dashboard instead.
		homeDashboard = "super-admin-analytics";
	} else {
		dynamicRoutes = company_apps;
		dynamicRoutes.push(...company_dashboard);
		homeDashboard = "dashboard-ecommerce";
	}
}

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{ path: "/", redirect: { name: homeDashboard } },
		...dynamicRoutes,
		// ...dashboard,
		...features,
		...pages,
		// ...chartsMaps,
		// ...formsTable,
		// ...uiElements,
		// ...others,
		{
			path: "*",
			redirect: "error-404",
		},
	],
});

router.beforeEach((to, _, next) => {
	// Re-check auth on every navigation (not stale load-time data)
	const isLoggedIn = isUserLoggedIn();
	const currentUserData = getUserData();

	if (!canNavigate(to)) {
		// Redirect to login if not logged in
		if (!isLoggedIn) return next({ name: "auth-login" });

		// If logged in => not authorized
		return next({ name: "misc-not-authorized" });
	}

	// Redirect if logged in
	if (to.meta.redirectIfLoggedIn && isLoggedIn) {
		return next(getHomeRouteForLoggedInUser(currentUserData ? currentUserData.role : null));
	}

	return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById("loading-bg");
	if (appLoading) {
		appLoading.style.display = "none";
	}
});

export default router;
